module.exports = __webpack_public_path__ + "img/world_2.a8dd55d3.svg";